import { useIntl } from "react-intl";

import Badge, { BadgeColor } from "components/v2/Badge/Badge";

import {
  QuoteRequestStatus,
  QuoteRequestStatusDisplay,
  ShipmentStatus,
  ShipmentStatusDisplay,
} from "../../../../../../../../constants";

const QuoteRequestStatusColors: Record<string, BadgeColor> = {
  [QuoteRequestStatus.OPEN_FOR_QUOTATIONS]: "success",
  [QuoteRequestStatus.CLOSED_FOR_QUOTATIONS]: "secondary-orange",
  [QuoteRequestStatus.CANCELED]: "error",
  [QuoteRequestStatus.AUTO_CANCELED]: "error",
  [QuoteRequestStatus.APPROVAL_PENDING]: "warning",
  [QuoteRequestStatus.AWAITING_ACTION]: "gray",
};

const ShipmentStatusColors: Record<number, BadgeColor> = {
  [ShipmentStatus.IN_TRANSIT]: "brand",
  [ShipmentStatus.DELIVERED]: "success",
  [ShipmentStatus.CANCELED]: "error",
  [ShipmentStatus.NEW]: "indigo",
  [ShipmentStatus.QUOTED]: "gray",
  [ShipmentStatus.DELAYED]: "warning",
  [ShipmentStatus.BOOKED]: "success",
  [ShipmentStatus.INCOMPLETE]: "gray",
  [ShipmentStatus.AUTO_CLOSED]: "error",
};

type BookmarkWidgetStatusBadgeProps = {
  bookmarkType: string;
  quoteRequestStatuses?: string[];
  shipmentStatus?: number;
  isLost?: boolean;
};

function BookmarkWidgetStatusBadge(props: BookmarkWidgetStatusBadgeProps) {
  const { bookmarkType, quoteRequestStatuses = [], shipmentStatus, isLost = false } = props;
  const intl = useIntl();

  if (isLost) {
    return (
      <Badge
        size="sm"
        color="error"
        type="status-badge"
        label={intl.formatMessage({ id: "general.lost", defaultMessage: "Lost" })}
      />
    );
  }

  return bookmarkType === "quote_request" ? (
    <div className="d-flex flex-wrap gap-xs">
      {quoteRequestStatuses?.length > 0 &&
        quoteRequestStatuses.map((status: string) => (
          <Badge
            key={status}
            size="sm"
            color={QuoteRequestStatusColors[status]}
            type="status-badge"
            label={QuoteRequestStatusDisplay[status]}
          />
        ))}
    </div>
  ) : (
    <Badge
      size="sm"
      color={ShipmentStatusColors[shipmentStatus as keyof typeof ShipmentStatusColors]}
      type="status-badge"
      label={ShipmentStatusDisplay[shipmentStatus as keyof typeof ShipmentStatusDisplay]}
    />
  );
}

export default BookmarkWidgetStatusBadge;

BookmarkWidgetStatusBadge.defaultProps = {
  quoteRequestStatuses: [],
  shipmentStatus: undefined,
  isLost: false,
};
